import { axios } from "../config/axios";

const endPoint = '/project/dashboard';

const getAvailableData = async () => {
    return axios.get(`${endPoint}/get-available-data`);
}

const getDashboardStats = async (body) => {
    return axios.post(`${endPoint}/dashboard-stats`, body);
}

// Counts per center (no candidate rows); used by the central Dashboard
const getCenterSummary = async (body) => {
    return axios.post(`${endPoint}/center-summary`, body);
}

// Open security alert counts per venue (from synced venue deviceLog); same filter body as center-summary
const getAlertSummary = async (body) => {
    return axios.post(`${endPoint}/alert-summary`, body);
}

// Alerts of one venue, loaded when its Alert Details popup opens
const getAlertList = async (venueMasterId, examDate) => {
    return axios.post(`${endPoint}/alert-list`, { venueMasterId, examDate });
}

export {
    getAvailableData,
    getDashboardStats,
    getCenterSummary,
    getAlertSummary,
    getAlertList,
}